import type { NotificationPolicy } from '@repo/api-gw-sdk';

import { Wizard } from '@/components/wizard/Wizard';

import {
  upsertNotificationPolicyFlow,
  type UpsertNotificationPolicyState,
} from './upsertNotificationPolicyFlow';

interface UpsertNotificationPolicyPanelProps {
  entity: NotificationPolicy;
  onSave: (notificationPolicy: NotificationPolicy) => Promise<void>;
  onAbort: () => void;
}

export function UpsertNotificationPolicyPanel(
  props: UpsertNotificationPolicyPanelProps
) {
  const save = async (state: UpsertNotificationPolicyState) => {
    await props.onSave(state);
    return true;
  };

  return (
    <Wizard<UpsertNotificationPolicyState>
      hideBackArrow={true}
      onAbort={props.onAbort}
      onFinish={save}
      initialStep={{ stepIndex: props.entity.id ? 1 : 0 }}
      flow={[upsertNotificationPolicyFlow]}
      initialState={{
        ...props.entity,
      }}
      title={
        props.entity.id
          ? `Edit notification policy`
          : `Create notification policy`
      }
    />
  );
}
